/**
 * Highlight colors system.
 *
 * Single color palette for all themes (light theme values).
 * The backend stores these hex values directly.
 *
 * All entries share the same structure: { slug, color, label }
 * The first 5 are the default built-in colors; the rest are available
 * for user-created custom highlighters.
 */

// ── Full palette ──────────────────────────────────────────────────────────────

export const ALL_PALETTE = [
    { slug: 'yellow', color: '#f5c542', label: 'yellow' },
    { slug: 'blue', color: '#4a9ede', label: 'blue' },
    { slug: 'rose', color: '#e8537a', label: 'rose' },
    { slug: 'orange', color: '#e88040', label: 'orange' },
    { slug: 'green', color: '#4db87a', label: 'green' },
    { slug: 'purple', color: '#9b6abf', label: 'purple' },
    { slug: 'teal', color: '#35a8a5', label: 'teal' },
    { slug: 'coral', color: '#e86050', label: 'coral' },
    { slug: 'lime', color: '#8cb83a', label: 'lime' },
    { slug: 'indigo', color: '#5c62c7', label: 'indigo' },
];

// ── Derived subsets ───────────────────────────────────────────────────────────

export const DEFAULT_HIGHLIGHT_COLORS = ALL_PALETTE.slice(0, 5);
export const EXTENDED_PALETTE = ALL_PALETTE.slice(5);

// ── Limits ────────────────────────────────────────────────────────────────────

export const MAX_CUSTOM_TAGS = 7;
export const MAX_TOTAL_TAGS = DEFAULT_HIGHLIGHT_COLORS.length + MAX_CUSTOM_TAGS;
